// SSR stub for react-icons — renders placeholder spans
function IconStub(props: any) {
  return <span {...props} style={{ display: 'inline-block', width: '1em', height: '1em' }} />
}

export const SiNpm = IconStub
export const SiIterm2 = IconStub
export const SiYcombinator = IconStub
export const FaGithub = IconStub
export const FaLinkedin = IconStub
export const FaHeart = IconStub
export const FaXTwitter = IconStub
export const FaCheck = IconStub
export const FaXmark = IconStub
export const RiTwitterXFill = IconStub

export default IconStub
